import React from "react";
import {
    Navigate,
} from "react-router-dom";

const StkCategoriesComponent = React.lazy(() => import("../../../../../components/stk-catalogues/components/categories/page"));
const StkProductsComponent = React.lazy(() => import("../../../../../components/stk-catalogues/components/products/page"));
const StkGeneralsComponent = React.lazy(() => import("../../../../../components/stk-catalogues/components/general/page"));

export const catalogueRoutes = [
    {
        path: 'categories',
        element: <StkCategoriesComponent />
    },
    {
        path: 'products',
        element: <StkProductsComponent />
    },
    {
        path: 'general',
        element: <StkGeneralsComponent />
    },
    {
        path: '',
        element: <Navigate replace to="/stockify/catalogues/categories" />
    },
];